'use strict';
import $ from 'jquery';

/**
 * 
 * @param {*} options 运行参数
 * elem: 元素容器
 * speed: 滚动速度
 * direction: 方向：vertical向上滚动,horizantal向左滚动
 */
function render(options) {
    const elem = options.elem;
    let direction = options.direction ? options.direction : 'vertical';
    let speed = options.speed ? (0 < 100 - options.speed && 100 - options.speed <= 100 ? 100 - options.speed : 30) : 30;
    let intId = [];

    if (!elem || !$(elem)) {
        throw new Error('没有在页面中找到需要滚动的元素!');
    }
    $(elem).children().each((i, item) => {
        item = $(item);
        // 水平滚动
        intId[i] = setInterval(function () {
            let sh;
            if (direction == 'horizantal') {
                sh = item.children().first().outerWidth(true);
            } else {
                sh = item.children().first().outerHeight(true);
            }
            marquee(item, sh, direction);
        }, speed);

        // 垂直滚动
        item.hover(function () {
            clearInterval(intId[i]);
        }, function () {
            intId[i] = setInterval(function () {
                let sh;
                if (direction == 'horizantal') {
                    sh = item.children().first().outerWidth(true);
                } else {
                    sh = item.children().first().outerHeight(true);
                }
                marquee(item, sh, direction);
            }, speed);
        });
    });
}

/**
 * 将指定元素滚动到指定方向一次
 * @param {*} obj jquery dom对象
 * @param {*} step 步长
 * @param {*} direction 方向
 */
function marquee(obj, step, direction) {
    if (direction == 'horizantal') {
        obj.animate({
            marginLeft: '-=1'
        }, 0, function () {
            var s = Math.abs(parseInt(obj.css("margin-left")));
            if (s >= step) {
                obj.children().slice(0, 1).appendTo($(this));
                obj.css("margin-left", 0);
            }
        });
    } else if (direction == 'vertical') {
        obj.animate({
            marginTop: '-=1'
        }, 0, function () {
            var s = Math.abs(parseInt(obj.css("margin-top")));
            if (s >= step) {
                obj.children().slice(0, 1).appendTo(obj);
                obj.css("margin-top", 0);
            }
        });
    }
}

export default { render: render };